import React from "react";
import { Skeleton } from "@components/ui/skeleton";

// interface SplashLoaderProps {
//     className?: string
// }

const SplashLoader: React.FC = () => {
  const prodType = sessionStorage.getItem("lsProductType");
  let logo = process.env.STATIC_PATH + "/images/linklogo.png";
  if (!prodType) {
    logo = process.env.STATIC_PATH + "/images/default-splash.png";
  } else if (prodType === "ctem") {
    logo = process.env.STATIC_PATH + "/images/ctem-splash.png";
  }
  return (
    <Skeleton className="h-[100vh] w-full flex justify-center items-center bg-black">
      <img src={logo} alt="linkshadow logo" className="opacity-50 w-[25vw]" />
    </Skeleton>
  );
};

export default SplashLoader;
